import { useAuth } from 'providers/user-context';

import AppInstructionsPage from './AppInstructionsPage';
import LandingInstructionsPage from './LandingInstructionsPage';

const InstructionsPage = () => {
  const { user } = useAuth();

  if (user) {
    return <AppInstructionsPage />;
  }

  return <LandingInstructionsPage />;
};

export default InstructionsPage;
